import api from './api';

export interface Company {
  id: number;
  name: string;
  domain: string;
  is_active: boolean;
  created_at: string;
}

export interface CompanyCreate {
  name: string;
  domain: string;
  is_active?: boolean;
}

export interface CompanyUpdate {
  name?: string;
  domain?: string;
  is_active?: boolean;
}

export const companiesService = {
  // Listar todas as empresas
  async getAll(): Promise<Company[]> {
    const response = await api.get('/api/v2/companies/');
    return response.data;
  },

  // Listar apenas empresas ativas
  async getActive(): Promise<Company[]> {
    const response = await api.get('/api/v2/companies/active');
    return response.data;
  },

  // Obter empresa por ID
  async getById(id: number): Promise<Company> {
    const response = await api.get(`/api/v2/companies/${id}`);
    return response.data;
  },

  // Criar nova empresa
  async create(data: CompanyCreate): Promise<Company> {
    const response = await api.post('/api/v2/companies/', data);
    return response.data;
  },

  // Atualizar empresa
  async update(id: number, data: CompanyUpdate): Promise<Company> {
    const response = await api.put(`/api/v2/companies/${id}`, data);
    return response.data;
  },

  // Deletar empresa
  async delete(id: number): Promise<void> {
    await api.delete(`/api/v2/companies/${id}`);
  },
};
